export default __webpack_public_path__ + "static/media/a7.84aa526a.png";